import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "scheduling-dialog-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "head" }, [
  /*#__PURE__*/_createVNode("span", null, "批量排班")
], -1)
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "date-selected" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("span", null, "已选日期")
], -1)
const _hoisted_6 = { class: "dates" }
const _hoisted_7 = { class: "time-person-list" }
const _hoisted_8 = { class: "time" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "已选时间段：", -1)
const _hoisted_11 = { class: "time-select-wrap" }
const _hoisted_12 = { class: "time-select" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", {
  style: {"color":"#d9d9d9"},
  class: "el-icon-minus"
}, null, -1)
const _hoisted_14 = { class: "persons-box" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "sep" }, "|", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, "请选择该时间段值班人", -1)
const _hoisted_17 = { class: "btn-add" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "添加时间段", -1)
const _hoisted_20 = { class: "dialog-footer" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("确 定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_time_select = _resolveComponent("el-time-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_SchedulingPersonSelect = _resolveComponent("SchedulingPersonSelect")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "close-on-click-modal": false,
    top: "0",
    width: 475,
    "destroy-on-close": "",
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.show = $event)),
    "show-close": false,
    "custom-class": "scheduling-dialog"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        model: _ctx.ruleForm,
        ref: "ruleFormRef"
      }, {
        default: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode("div", _hoisted_6, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ruleForm.datesSelected, (d, i) => {
                    return (_openBlock(), _createBlock("div", {
                      key: i,
                      class: "date"
                    }, [
                      _createVNode("span", null, _toDisplayString(`${d.month}月${d.date}日`), 1),
                      (_ctx.ruleForm.datesSelected.length > 1)
                        ? (_openBlock(), _createBlock("i", {
                            key: 0,
                            class: "el-icon-close",
                            onClick: ($event: any) => (_ctx.ruleForm.datesSelected.splice(i, 1))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(this.ruleForm.scheduleList, (s, i) => {
                  return (_openBlock(), _createBlock("div", {
                    key: i,
                    class: "item"
                  }, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode("i", {
                          onClick: ($event: any) => (_ctx.ruleForm.scheduleList.splice(i, 1)),
                          class: "el-icon-close"
                        }, null, 8, ["onClick"])
                      ]),
                      _createVNode("div", _hoisted_11, [
                        _createVNode("div", _hoisted_12, [
                          _createVNode(_component_el_time_select, {
                            onChange: ($event: any) => (_ctx.adjustEndTime(s)),
                            "prefix-icon": "",
                            clearable: false,
                            editable: true,
                            placeholder: "起始时间",
                            modelValue: s.startTime,
                            "onUpdate:modelValue": ($event: any) => (s.startTime = $event),
                            start: "00:00",
                            step: "01:00",
                            end: "23:00"
                          }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"]),
                          _hoisted_13,
                          _createVNode(_component_el_time_select, {
                            "prefix-icon": "",
                            clearable: false,
                            editable: true,
                            placeholder: "结束时间",
                            modelValue: s.endTime,
                            "onUpdate:modelValue": ($event: any) => (s.endTime = $event),
                            start: "00:00",
                            step: "01:00",
                            end: "24:00",
                            minTime: s.startTime
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "minTime"])
                        ])
                      ])
                    ]),
                    _createVNode(_component_el_form_item, {
                      rules: {
                validator: _ctx.scheduleListItemValidator, trigger: 'blur'
              },
                      required: "",
                      label: "已选值班人：",
                      class: "persons",
                      prop: 'scheduleList.' + i + '.persons'
                    }, {
                      default: _withCtx(() => [
                        _createVNode("div", _hoisted_14, [
                          (s.persons.length > 0)
                            ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(s.persons, (p, i) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: p.ldap,
                                  class: "person"
                                }, [
                                  _createVNode("span", null, _toDisplayString(p.name), 1),
                                  _hoisted_15,
                                  _createVNode("span", null, _toDisplayString(p.department), 1),
                                  _createVNode("i", {
                                    onClick: _withModifiers(($event: any) => (_ctx.deletePerson(s, i)), ["stop"]),
                                    class: "el-icon-close"
                                  }, null, 8, ["onClick"])
                                ]))
                              }), 128))
                            : (_openBlock(), _createBlock("div", {
                                key: 1,
                                onClick: _withModifiers(($event: any) => (_ctx.showSelectPersonDialog(s)), ["stop"])
                              }, [
                                _hoisted_16
                              ], 8, ["onClick"])),
                          _createVNode("i", {
                            onClick: ($event: any) => (_ctx.showSelectPersonDialog(s)),
                            class: "icon-arrow-right"
                          }, null, 8, ["onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["rules", "prop"])
                  ]))
                }), 128))
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  onClick: _ctx.addItem
                }, {
                  default: _withCtx(() => [
                    _hoisted_18,
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.submitSchedule
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createVNode(_component_el_dialog, {
              "destroy-on-close": "",
              modelValue: _ctx.showSchedulingPersonSelect,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSchedulingPersonSelect = $event)),
              "show-close": false,
              width: 429,
              "custom-class": "person-select-dialog"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SchedulingPersonSelect, {
                  personIds: _ctx.personIdSelectedInit,
                  cancel: _ctx.cancelPersonSelect,
                  submit: _ctx.submitPersonSelect
                }, null, 8, ["personIds", "cancel", "submit"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}